import React from 'react';
import { motion } from 'framer-motion';
import './Differentiators.css';

const differentiators = [
  {
    title: 'Context That Remembers',
    description: 'Your AI coach knows everything you\'ve logged. It\'s not starting from scratch each conversation - it has your complete fitness history.',
    visual: 'memory'
  },
  {
    title: 'One App, Complete Solution',
    description: 'Replace your workout tracker, food diary, and fitness coach with a single intelligent app that connects all the dots.',
    visual: 'unified'
  },
  {
    title: 'Real Data, Real Advice',
    description: 'No generic tips. Every recommendation is based on your actual workouts, meals, sleep patterns, and progress trends.',
    visual: 'data'
  }
];

const additionalFeatures = [
  'Apple Health integration',
  'Social progress feed',
  'Achievement streaks',
  'Progress photos',
  'Multiple themes',
  'Barcode scanner'
];

function Differentiators() {
  return (
    <section id="why-trackable" className="differentiators">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <h2>Why Trackable</h2>
          <p>Built different from the ground up. An AI that actually understands your fitness journey.</p>
        </motion.div>

        <div className="diff-grid">
          {differentiators.map((item, index) => (
            <motion.div 
              key={index}
              className="diff-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className={`diff-visual ${item.visual}`}>
                {item.visual === 'memory' && (
                  <div className="visual-memory">
                    <div className="memory-line" />
                    <div className="memory-nodes">
                      <span /><span /><span /><span /><span />
                    </div>
                    <div className="memory-line" />
                  </div>
                )}
                {item.visual === 'unified' && (
                  <div className="visual-unified">
                    <div className="unified-center" />
                    <div className="unified-orbit">
                      <span /><span /><span />
                    </div>
                  </div>
                )}
                {item.visual === 'data' && (
                  <div className="visual-data">
                    <div className="data-bars">
                      <span style={{ height: '40%' }} />
                      <span style={{ height: '70%' }} />
                      <span style={{ height: '55%' }} />
                      <span style={{ height: '85%' }} />
                      <span style={{ height: '60%' }} />
                    </div>
                  </div>
                )}
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="additional-features"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.6 }}
        >
          <h3>Plus everything you expect</h3>
          <div className="features-list">
            {additionalFeatures.map((feature, index) => (
              <div key={index} className="feature-tag">
                <svg viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                {feature}
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Differentiators;
